module.exports = __webpack_public_path__ + "static/media/vert.4214e40a.png";